import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getUds({
      rootGetters
    }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/uniquedevice/web/getqrsbybranch?id=" + rootGetters.getBranch.id,
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    genQrCode({
      rootGetters
    }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/uniquedevice/web/qrcode?id=" + rootGetters.getBranch.id,
          data: obj,
          method: "POST"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQr(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/uniquedevice/web/getqrsbyid?id=" + id,
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    deleteNewQr(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/uniquedevice/web/deleteempqr?id=" + id,
          method: "DELETE"
        }).then(response => {
          if (response.data.status) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    unLinkQR(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/logout/webudqrlogout?id=" + id,
          method: "PUT"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },



    genQrCodeK() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/klipydevice/web/qrcode",
          method: "POST"
        }).then(response => {
          if (response) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQrK(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/klipydevice/web/getById?id=" + id,
          method: "GET"
        }).then(response => {
          if (response) {
            resolve(response)
          }
          reject(response)
        }).catch( {
        })
      })
    },
    getKlipy() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/klipydevice/web/getByBranch",
          method: "GET"
        }).then(response => {
          if (response) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    unLinkQRK(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/logout/web/kdqrlogout?id=" + id,
          method: "PUT"
        }).then(response => {
          if (response.status) {
            resolve(response);
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    deleteNewQrK(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/klipydevice/web/deleteQR?id=" + id,
          method: "DELETE"
        }).then(response => {
          if (response) {
            resolve(response)
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    editNameK(o, obj) {
      return new Promise((resolve, reject) => {
        console.log(obj)
        
        axios({
          url: process.env.VUE_APP_URL + "/klipydevice/web/" + obj.id + "/updateName",
          data: {deviceName: obj.deviceName},
          method: "PUT"
        }).then(response => {
          if (response.status) {
            resolve(response);
          }
          reject(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    editIpadName(_, {idDevice = 0, body = {}} = {}) {
        axios({
          url: `${process.env.VUE_APP_URL}/employee/web/${idDevice}/updateName`,
          method: "PUT",
          data: body,
        })
    },
  }
}